import { registerLibraries } from '@xing-com/crate-runtime-libraries';
import type { GlobalScope } from '@xing-com/crate-xinglet/internal';

declare const globalThis: GlobalScope;

registerLibraries(globalThis);
